import React from 'react';
import './Navbar.css';


const Navbar = ({ company, onLogout, logoPath}) => {

  return (
    <nav className="navbar">
      {logoPath && <img src={logoPath} alt={`${company} Logo`} className="navbar-logo" />}
      {company && (
        <button onClick={onLogout} className="logout-button">Logout</button>
      )}
    </nav>
  );
};

export default Navbar;
